/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuConfigurationsResponse } from '../../models/menu-configurations-response';
import { MenuType } from '../../models/menu-type';
import { PublishConfigurationInputs } from '../../models/publish-configuration-inputs';

export interface PublishConfigurationsTypePost$Params {
  'Active-Tenant-Identifier': string;
  type: MenuType;
  PublishConfigurationInput: PublishConfigurationInputs;
}

export function publishConfigurationsTypePost(http: HttpClient, rootUrl: string, params: PublishConfigurationsTypePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuConfigurationsResponse>> {
  const rb = new RequestBuilder(rootUrl, publishConfigurationsTypePost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('type', params.type, {});
    rb.body(params.PublishConfigurationInput, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuConfigurationsResponse>;
    })
  );
}

publishConfigurationsTypePost.PATH = '/publish-configurations/{type}';
